import SortDirection, { type SortDirectionType } from '@rio-cloud/rio-uikit/SortDirection';

export const DEFAULT_ROUTE = '/app-logins';
const SEARCH_QUERY_PARAM = 'q';
const LEGACY_SEARCH_QUERY_PARAM = 'search';
const SORT_QUERY_PARAM = 'sort';
const DEFAULT_SORT_BY = 'description';
const DEFAULT_SORT_DIR = SortDirection.ASCENDING;

export const routes = [DEFAULT_ROUTE];

export interface RouteState {
    search: string | undefined;
    sortBy: string | undefined;
    sortDir: SortDirectionType | undefined;
}

export const parseRoute = (locationSearch: string): RouteState => {
    const queryParams = new URLSearchParams(locationSearch.startsWith('?') ? locationSearch.slice(1) : locationSearch);
    const parsedSort = parseSortQuery(queryParams.get(SORT_QUERY_PARAM) ?? undefined);

    return {
        search: queryParams.get(SEARCH_QUERY_PARAM) ?? queryParams.get(LEGACY_SEARCH_QUERY_PARAM) ?? undefined,
        sortBy: parsedSort?.sortBy,
        sortDir: parsedSort?.sortDir,
    } as RouteState;
};

export const makeRoute = (searchParams: RouteState): string => {
    const queryParams = new URLSearchParams();
    const search = searchParams.search || undefined;
    const sort = createSortQuery(searchParams.sortBy, searchParams.sortDir);

    if (search) {
        queryParams.set(SEARCH_QUERY_PARAM, search);
    }

    if (sort) {
        queryParams.set(SORT_QUERY_PARAM, sort);
    }

    const queryString = queryParams.toString();
    return queryString ? `?${queryString}` : '';
};

export const getDefaultRouteState = (): RouteState => ({
    search: undefined,
    sortBy: DEFAULT_SORT_BY,
    sortDir: DEFAULT_SORT_DIR,
});

const parseSortQuery = (sort: string | undefined): Pick<RouteState, 'sortBy' | 'sortDir'> | undefined => {
    if (!sort) {
        return undefined;
    }

    const sortDir = sort.startsWith('-')
        ? SortDirection.DESCENDING
        : sort.startsWith('+')
          ? SortDirection.ASCENDING
          : undefined;

    if (!sortDir) {
        return undefined;
    }

    return {
        sortBy: sort.slice(1),
        sortDir,
    };
};

const createSortQuery = (sortBy: string | undefined, sortDir: SortDirectionType | undefined): string | undefined => {
    if (!sortBy || !sortDir || (sortBy === DEFAULT_SORT_BY && sortDir === DEFAULT_SORT_DIR)) {
        return undefined;
    }

    return `${sortDir === SortDirection.ASCENDING ? '+' : '-'}${sortBy}`;
};
